import React, { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import { AGENT_CATEGORIES } from "@lib/agentConsole";
import type { I18nT } from "@lib/dashboardI18n";

const QaAgentsForNRO = lazy(() =>
  import("@scenes/AgentsList").then((module) => ({
    default: () => React.createElement(module.AgentConsoleForNro, { category: AGENT_CATEGORIES.QA }),
  }))
);

export const qaAgentsNRO: NavigationRoutingObject = {
  Component: QaAgentsForNRO,
  noKnockoutFallback: true,
  componentFeatureFlippers: ["agent_console_campaign_qa"],
  section: "agent-console",
  icon: "new-nav-system-agent-management",
  heading: (t: I18nT<"dashboard-navigation">) => t("qa-agents-nro-heading", "QA Agents"),
  pageNameForTracking: () => "QA Agents",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("qa-agents-nro-description", "Check campaigns, Canvases, and content against custom rules before launch"),
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
